"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var SleepSettingsService = (function () {
    function SleepSettingsService() {
    }
    SleepSettingsService.getCurrentWeekday = function (timezone) {
        return moment_timezone_1.default.tz(new Date().toISOString(), timezone !== null && timezone !== void 0 ? timezone : "Europe/Moscow").isoWeekday();
    };
    SleepSettingsService.pickSleepOption = function (weekday, options) {
        return options[weekday - 1];
    };
    SleepSettingsService.getYesterdayAndTomorrow = function (weekday) {
        return {
            yesterday: weekday === 1 ? 7 : weekday - 1,
            tomorrow: weekday === 7 ? 1 : weekday + 1,
        };
    };
    SleepSettingsService.getMinusDayModifier = function () {
        return function (timestamp) { return timestamp - 86400 * 1000; };
    };
    SleepSettingsService.getPlusDayModifier = function () {
        return function (timestamp) { return timestamp + 86400 * 1000; };
    };
    SleepSettingsService.applyModifierToInterval = function (interval, modifier) {
        return {
            start: modifier(interval.start),
            end: modifier(interval.end),
        };
    };
    SleepSettingsService.convertIntervalIntoTimestamp = function (interval, timezone, date) {
        var _a = __read(interval.split(":").map(function (item) { return Number(item); }), 3), hours = _a[0], minutes = _a[1], seconds = _a[2];
        var nowAsTimezone = (0, moment_timezone_1.default)(date || Date.now()).tz(timezone !== null && timezone !== void 0 ? timezone : "Europe/Moscow");
        nowAsTimezone.set({
            h: hours,
            m: minutes,
            s: seconds,
        });
        return nowAsTimezone.toDate().getTime();
    };
    SleepSettingsService.timestampAsDatetime = function (timestamp) {
        return (0, moment_timezone_1.default)(timestamp).toISOString();
    };
    SleepSettingsService.convertIntervalPair = function (interval, timezone, date) {
        var start = this.convertIntervalIntoTimestamp(interval.start, timezone, date);
        var end = this.convertIntervalIntoTimestamp(interval.end, timezone, date);
        return {
            start: start,
            end: start > end ? this.getPlusDayModifier()(end) : end,
        };
    };
    SleepSettingsService.getCurrentWorkIntervals = function (options, timezone) {
        var today = this.getCurrentWeekday(timezone);
        var _a = this.getYesterdayAndTomorrow(today), yesterday = _a.yesterday, tomorrow = _a.tomorrow;
        return {
            yesterday: this.applyModifierToInterval(this.convertIntervalPair(this.pickSleepOption(yesterday, options), timezone), this.getMinusDayModifier()),
            today: this.convertIntervalPair(this.pickSleepOption(today, options), timezone),
            tomorrow: this.applyModifierToInterval(this.convertIntervalPair(this.pickSleepOption(tomorrow, options), timezone), this.getPlusDayModifier()),
        };
    };
    SleepSettingsService.getWorkingIntervalByDate = function (date, options, timezone) {
        var weekday = (0, moment_timezone_1.default)(date)
            .tz(timezone !== null && timezone !== void 0 ? timezone : "Europe/Moscow")
            .isoWeekday();
        return this.convertIntervalPair(this.pickSleepOption(weekday, options), timezone, date);
    };
    SleepSettingsService.formatTimestamp = function (timestamp, timezone) {
        return (0, moment_timezone_1.default)(timestamp)
            .tz(timezone !== null && timezone !== void 0 ? timezone : "Europe/Moscow")
            .format("HH:mm");
    };
    SleepSettingsService.shouldSleepNow = function (intervals, sleepMode) {
        var now = Date.now();
        if (!sleepMode) {
            return {
                shouldSleepNow: false,
            };
        }
        if (intervals.yesterday.end <= now && now <= intervals.today.start) {
            return {
                shouldSleepNow: true,
                start: intervals.yesterday.end,
                end: intervals.today.start,
            };
        }
        if (intervals.today.end <= now && now <= intervals.tomorrow.start) {
            return {
                shouldSleepNow: true,
                start: intervals.today.end,
                end: intervals.tomorrow.start,
            };
        }
        return {
            shouldSleepNow: false,
        };
    };
    return SleepSettingsService;
}());
exports.default = SleepSettingsService;
//# sourceMappingURL=index.js.map